import { Box, Typography } from "@mui/material";
import { AppointmentParticipantDetail } from "./appointmentParticipantTypes";
import AppointmentParticipantDetailStack from "./AppointmentParticipantDetailStack";

type Props = {
  participants: AppointmentParticipantDetail[];
};

const AppointmentParticipantsSection = ({ participants }: Props) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        Participants
      </Typography>
      {participants.length > 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {participants.map((participant, index) => (
            <AppointmentParticipantDetailStack
              key={participant.id}
              index={index + 1}
              participant={participant}
            />
          ))}
        </Box>
      ) : (
        <Typography variant="body1" color="text.secondary">
          No participants
        </Typography>
      )}
    </Box>
  );
};

export default AppointmentParticipantsSection;
